import { render, staticRenderFns } from "./Masonry.vue?vue&type=template&id=19fd4c85&scoped=true"
import script from "./Masonry.vue?vue&type=script&lang=js"
export * from "./Masonry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd4c85",
  null
  
)

export default component.exports